/** Matches shared skill collection file preview Monaco options (read-only). */
export const FILE_PREVIEW_MONACO_OPTIONS = {
  readOnly: true,
  minimap: { enabled: false },
  scrollBeyondLastLine: false,
  fontSize: 13,
  lineHeight: 20,
  padding: { top: 12, bottom: 12 },
  automaticLayout: true,
} as const;
